import type { OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FmLoadingPageService } from '../../../shared/services/fm-loading-page.service';
import { StringConstants } from '../../constants/string-constants';
import { PricingFileUploadService } from '../pricing-file-upload.service';

@Component({
  standalone: false,
  selector: 'invd-pricing-file-upload',
  templateUrl: './pricing-file-upload.component.html',
  styleUrls: ['./pricing-file-upload.component.css'],
})
export class PricingFileUploadComponent implements OnInit {
  public alert: any;
  public uploadedFiles: any;
  public alertModel: any;
  dropzoneActive = false;
  public isMultipleFiles = false;
  public displayUploadSuccessPopup = false;
  public displayUploadErrorPopup = false;
  public hasFileExtensionError = false;

  public fmLoadingPageService = inject(FmLoadingPageService);
  private pricingFileUploadService = inject(PricingFileUploadService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.displayUploadSuccessPopup = false;
    this.displayUploadErrorPopup = false;
    this.hasFileExtensionError = false;
    this.subscribeToFileUploadFailUpdates();
  }

  public onREMICUpload(event) {
    this.hasFileExtensionError = false;
    this.fmLoadingPageService.isLoaderRequesting.set(true);
    this.alert = {};

    if (event.target.files && event.target.files[0] && event.target.files[0].name) {
      let fileExtension = '';

      fileExtension = event.target.files[0].name.split('.')[1];

      this.hasFileExtensionError =
        fileExtension !== StringConstants.FILE_TYPE_ALLOWED ? true : false;
    }

    if (!this.hasFileExtensionError) {
      this.pricingFileUploadService.handleREMICUploadProcess(event.target.files).subscribe({
        next: (data) => {
          if (data) {
            this.handleFileUploadSuccess();
          }
        },
        error: (_error) => {
          console.log('error in file upload');
          this.cdr.markForCheck();
        },
      });
    } else {
      this.fmLoadingPageService.isLoaderRequesting.set(false);
    }
  }

  public handleFileUploadSuccess() {
    this.displayUploadSuccessPopup = true;
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.cdr.markForCheck();
  }

  public handleFileUploadFail() {
    this.displayUploadErrorPopup = true;
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.cdr.markForCheck();
  }

  private subscribeToFileUploadFailUpdates(): void {
    this.pricingFileUploadService.fileUploadFailSubscription$.subscribe({
      next: (_error: any) => {
        console.log('error');
        this.handleFileUploadFail();
      },
      error: (error: any) => {
        console.log(error);
        this.cdr.markForCheck();
      },
    });
  }

  protected resetInput($event: MouseEvent) {
    const target = $event.target as HTMLInputElement;

    target.value = null;
  }
}
